<div id="about-container">
  <div id="headers-container">
    <h2 class="header" [ngClass]="{'selected': nav.bulgariaSelected}" (click)="clickBulgaria()">
      {{'BULGARIA' | translate | uppercase}}</h2>
    <h2 class="header" [ngClass]="{'selected': nav.varnaSelected}" (click)="clickVarna()">
      {{'VARNA' | translate | uppercase}}</h2>
    <h2 class="header" [ngClass]="{'selected': nav.regionsSelected}" (click)="clickRegions()">
      {{'AREAS_AND_REGIONS' | translate | uppercase}}</h2>
  </div>

  <div class="content-container" *ngIf="ls.bulgariaArticle && nav.bulgariaSelected">
    <h3 class="title">{{ 'BULGARIA' | translate }}</h3>
    <div class="content" [innerHTML]='ls.bulgariaArticle | translatedb'></div>
  </div>
  <div class="content-container" *ngIf="ls.varnaArticle && nav.varnaSelected">
    <h3 class="title">{{ 'VARNA' | translate }}</h3>
    <div class="content" [innerHTML]='ls.varnaArticle | translatedb'></div>
  </div>

  <div class="content-container" *ngIf="ls.regions && nav.regionsSelected">
    <div id="regions-container">
      <div class="region-title" *ngFor="let region of ls.regions"
           (click)="this.selectedRegion = region.article"
           [ngClass]="{'selected': region.article === selectedRegion}">{{region.header | translatedb}}</div>
    </div>
    <div class="selected-region" *ngIf="this.selectedRegion" [innerHTML]="getSelectedRegionText()"></div>
  </div>
</div>
